function waitForGrecaptchaReady(): Promise<void> {
  return new Promise((resolve) => {
    if (window.grecaptcha?.ready) {
      window.grecaptcha.ready(() => resolve())
      return
    }
    resolve()
  })
}

export function loadRecaptchaV2Script(): Promise<void> {
  if (window.grecaptcha?.render) return waitForGrecaptchaReady()
  if (window.__recaptchaV2ScriptLoading) return window.__recaptchaV2ScriptLoading

  window.__recaptchaV2ScriptLoading = new Promise<void>((resolve, reject) => {
    const finish = () => waitForGrecaptchaReady().then(resolve).catch(reject)
    const existing = document.querySelector<HTMLScriptElement>(
      'script[src*="google.com/recaptcha/api.js?render=explicit"]',
    )
    if (existing) {
      if (window.grecaptcha?.render) {
        finish()
        return
      }
      existing.addEventListener('load', () => finish(), { once: true })
      existing.addEventListener('error', () => reject(new Error('reCAPTCHA yüklenemedi')), {
        once: true,
      })
      window.setTimeout(() => {
        if (window.grecaptcha?.render) finish()
      }, 50)
      return
    }
    const script = document.createElement('script')
    script.src = 'https://www.google.com/recaptcha/api.js?render=explicit'
    script.async = true
    script.defer = true
    script.onload = () => finish()
    script.onerror = () => reject(new Error('reCAPTCHA yüklenemedi'))
    document.head.appendChild(script)
  })

  return window.__recaptchaV2ScriptLoading
}
